module.exports = __webpack_public_path__ + "img/arrow_left_green.7426fe58.svg";